import { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './DonationPage.css';

const DonationPage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');
  const [method, setMethod] = useState('');
  const [donorName, setDonorName] = useState('');
  const [donorEmail, setDonorEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvc, setCardCvc] = useState('');
  const [cardHolder, setCardHolder] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/donations/settings`);
        const data = await res.json();
        setSettings(data);
      } catch { setSettings({ enabled: false }); }
      setLoading(false);
    };
    fetchSettings();
  }, []);

  const getAmount = () => selectedAmount || parseInt(customAmount, 10) || 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const amount = getAmount();
    if (!amount || amount <= 0) { setError('Lütfen bir tutar seçin.'); return; }
    if (!method) { setError('Lütfen ödeme yöntemi seçin.'); return; }

    if ((method === 'iyzico' || method === 'paytr') && (!cardNumber || !cardExpiry || !cardCvc || !cardHolder)) {
      setError('Lütfen kart bilgilerini doldurun.');
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/donations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount,
          method,
          donorName: donorName || 'Anonim',
          donorEmail,
          note: method === 'eft' ? 'EFT ile ödeme' : 'Kart ile ödeme',
        }),
      });
      if (!res.ok) { const data = await res.json(); throw new Error(data.message); }
      setSuccess(true);
    } catch (err) { setError(err.message || 'İşlem başarısız.'); }
    setSubmitting(false);
  };

  if (loading) return <div className="donation-page"><Navigation /><div className="donation-container" style={{ textAlign: 'center', paddingTop: '4rem' }}>Yükleniyor...</div></div>;
  if (!settings?.enabled) return <div className="donation-page"><Navigation /><div className="donation-container" style={{ textAlign: 'center', paddingTop: '4rem' }}><h2>Bağış modülü şu an aktif değil.</h2></div><Footer /></div>;

  return (
    <div className="donation-page">
      <Navigation />
      <div className="donation-container">
        <div className="donation-header">
          <h1>{settings.title || 'Bağış Yap'}</h1>
          <p>{settings.description}</p>
        </div>

        <div className="donation-card">
          {success ? (
            <div className="donation-success">
              <svg width="64" height="64" fill="none" stroke="#10b981" viewBox="0 0 24 24" style={{ margin: '0 auto' }}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <h3>Teşekkürler!</h3>
              <p>{method === 'eft' ? 'EFT bilgileri aşağıda. Ödemenizi yaptıktan sonra onaylanacaktır.' : 'Bağışınız başarıyla alındı. Teşekkür ederiz.'}</p>
              {method === 'eft' && settings.eftEnabled && (
                <div className="donation-eft-info" style={{ marginTop: '1rem', textAlign: 'left' }}>
                  <h4>Havale Bilgileri</h4>
                  <p><strong>Banka:</strong> {settings.eftBankName}</p>
                  <p><strong>Hesap Sahibi:</strong> {settings.eftAccountHolder}</p>
                  <p><strong>IBAN:</strong> {settings.eftIban}</p>
                  <p><strong>Tutar:</strong> {getAmount()} TL</p>
                  {settings.eftDescription && <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: '#6b7280' }}>{settings.eftDescription}</p>}
                </div>
              )}
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <div className="donation-error">{error}</div>}

              {/* Tutar Seçimi */}
              <div className="donation-amounts">
                {(settings.amounts || [10, 25, 50, 100, 250, 500]).map(amt => (
                  <button key={amt} type="button" className={`donation-amount-btn ${selectedAmount === amt ? 'selected' : ''}`} onClick={() => { setSelectedAmount(amt); setCustomAmount(''); }}>
                    {amt} ₺
                  </button>
                ))}
              </div>

              {settings.customAmount !== false && (
                <input
                  type="number"
                  className="donation-custom-input"
                  placeholder="Özel tutar (₺)"
                  value={customAmount}
                  onChange={(e) => { setCustomAmount(e.target.value); setSelectedAmount(null); }}
                  min="1"
                />
              )}

              {/* Ödeme Yöntemi */}
              <div className="donation-methods">
                {settings.iyzicoEnabled && (
                  <button type="button" className={`donation-method-btn ${method === 'iyzico' ? 'selected' : ''}`} onClick={() => setMethod('iyzico')}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
                    <span>Kredi / Banka Kartı (iyzico)</span>
                  </button>
                )}
                {settings.paytrEnabled && (
                  <button type="button" className={`donation-method-btn ${method === 'paytr' ? 'selected' : ''}`} onClick={() => setMethod('paytr')}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
                    <span>Kredi / Banka Kartı (PayTR)</span>
                  </button>
                )}
                {settings.eftEnabled && (
                  <button type="button" className={`donation-method-btn ${method === 'eft' ? 'selected' : ''}`} onClick={() => setMethod('eft')}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                    <span>EFT / Havale</span>
                  </button>
                )}
              </div>

              {/* Kart Bilgileri (iyzico/paytr) */}
              {(method === 'iyzico' || method === 'paytr') && (
                <div className="donation-card-form">
                  <h4>Kart Bilgileri</h4>
                  <div className="donation-form-group">
                    <label>Kart Üzerindeki İsim</label>
                    <input type="text" value={cardHolder} onChange={(e) => setCardHolder(e.target.value)} placeholder="Ad Soyad" required />
                  </div>
                  <div className="donation-form-group">
                    <label>Kart Numarası</label>
                    <input type="text" value={cardNumber} onChange={(e) => setCardNumber(e.target.value.replace(/\D/g, '').slice(0, 16))} placeholder="0000 0000 0000 0000" maxLength="16" required />
                  </div>
                  <div className="donation-card-row">
                    <div className="donation-form-group">
                      <label>Son Kullanma</label>
                      <input type="text" value={cardExpiry} onChange={(e) => setCardExpiry(e.target.value)} placeholder="AA/YY" maxLength="5" required />
                    </div>
                    <div className="donation-form-group">
                      <label>CVC</label>
                      <input type="text" value={cardCvc} onChange={(e) => setCardCvc(e.target.value.replace(/\D/g, '').slice(0, 4))} placeholder="000" maxLength="4" required />
                    </div>
                  </div>
                </div>
              )}

              {/* EFT Bilgileri */}
              {method === 'eft' && settings.eftEnabled && (
                <div className="donation-eft-info">
                  <h4>Havale Bilgileri</h4>
                  <p><strong>Banka:</strong> {settings.eftBankName}</p>
                  <p><strong>Hesap Sahibi:</strong> {settings.eftAccountHolder}</p>
                  <p><strong>IBAN:</strong> {settings.eftIban}</p>
                  {settings.eftDescription && <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: '#6b7280' }}>{settings.eftDescription}</p>}
                </div>
              )}

              {/* Bağışçı Bilgileri */}
              <div className="donation-card-row" style={{ marginBottom: '1.5rem' }}>
                <div className="donation-form-group">
                  <label>Ad Soyad (opsiyonel)</label>
                  <input type="text" value={donorName} onChange={(e) => setDonorName(e.target.value)} placeholder="Anonim" />
                </div>
                <div className="donation-form-group">
                  <label>E-posta (opsiyonel)</label>
                  <input type="email" value={donorEmail} onChange={(e) => setDonorEmail(e.target.value)} />
                </div>
              </div>

              <button type="submit" className="donation-submit" disabled={submitting}>
                {submitting ? 'İşleniyor...' : `${getAmount() || '...'} ₺ Bağış Yap`}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DonationPage;
